import { render, staticRenderFns } from "./ContentHeader.vue?vue&type=template&id=2ff263d4"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports